/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.groups.controllers', [])

.controller('GroupsController', ['$scope', function($scope) {

    $scope.groups = {

      model: "Your spankin new application.groups.default view!",

      init: function() {},


      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.groups.init();

}]);